import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram, FiPhoneCall} from 'react-icons/fi';

import './Footer.css';
import { FooterOverlay } from '../../components/Footer/FooterOverlay';
import { Newsletter } from '../../components/Footer/Newsletter';
import { dots, gericht, name, spoon } from '../../constants/images';

export const Footer = () => (
  <div className="app__footer section__padding" id="login">
    <FooterOverlay />
    <Newsletter />

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">Rm 24 Buffallo Mall, Naivasha-Nakuru Exit Junction, Naivasha, Kenya</p>
        <p className="p__opensans">+254 727 449 975 </p>
        <p className="p__opensans">+254 706 561 404 </p>
      </div>

      <div className="app__footer-links_logo">
        <img src={name} alt="footer_logo" />
        <p className="p__opensans">&quot;The best time to live is now, the next best time to live is now.&quot;</p>
        <img src={dots} className="spoon__img" style={{ marginTop: 15 }} />
        <div className="app__footer-links_icons">
          <FiFacebook />
          <FiTwitter />
          <FiInstagram />
          <FiPhoneCall />
        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Working Hours</h1>
        <p className="p__opensans">We work all day, all night. But for the offices:</p>
        <p className="p__opensans">Monday-Friday:</p>
        <p className="p__opensans">07:00 am - 06:00 pm</p>
        <p className="p__opensans">Saturday-Sunday:</p>
        <p className="p__opensans">08:00 am - 07:00 pm</p>
      </div>
    </div>

    <div className="footer__copyright">
      <p className="p__opensans"> Copyright <span>&copy;</span> {new Date().getFullYear()} DGA Tours and Travel. All Rights reserved.</p>
    </div>

  </div>
);

// export default Footer;
